import { IconProps } from '@tamagui/helpers-icon';
import { Pressable } from '@unistocks/components/basic/pressable';
import { Text } from '@unistocks/components/text/text';
import { quicker } from '@unistocks/shared/animations';
import { useIsKeyboardShown } from '@unistocks/shared/hooks/use-is-keyboard-shown';
import { BottomTabBarButtonProps } from 'expo-router/build/react-navigation/bottom-tabs';
import Animated, { useAnimatedStyle, withSpring } from 'react-native-reanimated';

const TRANSFORM_HIDDEN = 8.5;
const TRANSFORM_VISIBLE = -18;

export type TabBarButtonProps = Omit<BottomTabBarButtonProps, 'href'> & {
  Icon: React.ComponentType<IconProps>;
  label: string;
};

export const TabBarButton: React.FC<TabBarButtonProps> = ({
  Icon,
  label,
  children,
  style,
  // TODO: If possible, pass params to onPress navigate function. To be able to have a route like portfolio/[id]/ on a tab bar button
  onPress,
  ...props
}) => {
  const keyboardShown = useIsKeyboardShown();
  const active = !!props['aria-selected'];
  const translateY = active && !keyboardShown ? TRANSFORM_VISIBLE : TRANSFORM_HIDDEN;

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ translateY: withSpring(translateY, quicker) }]
  }));

  const animatedIconStyle = useAnimatedStyle(() => ({
    transform: [{ scale: withSpring(active ? 1.3 : 1, quicker) }]
  }));

  const animatedTextStyle = useAnimatedStyle(() => ({
    opacity: withSpring(active ? 1 : 0, quicker)
  }));

  return (
    <Animated.View style={[animatedStyle, style]}>
      <Pressable
        withFeedback
        gap={'$2.5'}
        alignItems="center"
        {...(props as any)}
        onPress={onPress}
      >
        <Animated.View style={animatedIconStyle}>
          <Icon color={active ? '$unistocks' : '$gray11'} size={'$2.5'} />
        </Animated.View>

        <Animated.View style={animatedTextStyle}>
          <Text
            fontSize={'$2'}
            fontWeight={'$7'}
            lineHeight={'$1'}
            color={'$unistocks'}
            textAlign={'center'}
            userSelect={'none'}
            allowFontScaling={false}
            numberOfLines={1}
          >
            {label}
          </Text>
        </Animated.View>
      </Pressable>
    </Animated.View>
  );
};
